import store from "@/store";

export function segmentAnalytics(event) {
  const user = store.state.user;
  // eslint-disable-next-line no-undef
  analytics.track(
    event,
    user && {
      email: user.email,
      name: user.name,
      customer: user.company,
    },
  );
}

export function segmentExportAnalytics(event, scheduleRange, rowsRange) {
  const user = store.state.user;
  // eslint-disable-next-line no-undef
  analytics.track(
    event,
    user && {
      email: user.email,
      name: user.name,
      customer: user.company,
      scheduleRange: scheduleRange,
      rowsRange: rowsRange,
    },
  );
}
